import { render, staticRenderFns } from "./CRMAllCreate.vue?vue&type=template&id=cb003146&scoped=true"
import script from "./CRMAllCreate.vue?vue&type=script&lang=js"
export * from "./CRMAllCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb003146",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb003146')) {
      api.createRecord('cb003146', component.options)
    } else {
      api.reload('cb003146', component.options)
    }
    module.hot.accept("./CRMAllCreate.vue?vue&type=template&id=cb003146&scoped=true", function () {
      api.rerender('cb003146', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/components/CRMAllCreate.vue"
export default component.exports